<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<div class="col-lg-12">
				<div class="card card-primary card-outline">
					<div class="card-header">

					</div>
					<div class="card-body overflow-auto">
						{{campaign}}
						<div class="form-group">
									<label>Category</label>
									<select class="form-control" v-model="categoryid" @change="getDivisions('filter')">
										<option v-for="i in categories" :value="i.id">{{i.name}}</option>
									</select>
								</div>
								<div class="form-group">
									<label>Product</label>
									<select class="form-control" v-model="product">
										<option v-for="i in products" :value="i.product_name">{{i.product_name}}</option>
									</select>
								</div>
								<div class="form-group">
									<label>Division</label>
									<select class="form-control" v-model="division">
										<option v-for="i in divisions" :value="i.name">{{i.name}}</option>
									</select>
								</div>
								<div class="form-group">
									<label>Lower Limit</label>
									<input type="number" class="form-control" placeholder="Enter the lower limit" v-model="lower" min="0">
								</div>
								<div class="form-group">
									<label>Upper Limit</label>
									<input type="number" class="form-control" placeholder="Enter the upper limit" v-model="upper" min="0">
								</div>
								<button class="btn btn-primary" @click="getRules('/api/getGiftCampaignRules')">Search</button>
								<button class="btn btn-primary" @click="reset">Reset</button>
								<table class="table table-hover table-striped table-bordered">
									<thead>
										<tr>
											<th scope="col">Category</th>
											<th scope="col">Product</th>
											<th scope="col">Division</th>
											<th scope="col">Item Code</th>
											<th scope="col">Price Limit</th>
											<th scope="col">Assigned Gift</th>
											<th scope="col">Available Quantity</th>
											<th scope="col">Alloted Quantity</th>
											<th scope="col">Remaining Quantity</th>
											<th scope="col">Manage</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="r in rules">
											<td>{{r.category}}</td>
											<td>{{r.product}}</td>
											<td>{{r.division}}</td>
											<td>{{r.itemcode}}</td>
											<td>{{r.lower_price_limit}}-{{r.upper_price_limit}}</td>
											<td>{{r.assigned_gift}}</td>
											<td>{{r.available_quantity}}</td>
											<td>{{r.alloted_quantity}}</td>
											<td>{{r.remaining_quantity}}</td>
											<td>
												<button class="btn btn-primary" @click="changePrompt(r.id)">Change</button>
											</td>
										</tr>
									</tbody>
									<tfoot>
										<pagination :pagination="pagination"
										 	@prev="getRules(pagination.prevPageUrl)"
											@next="getRules(pagination.nextPageUrl)"
										></pagination>
									</tfoot>
								</table>
					</div>
					<div class="card-footer">
						<form @submit.prevent="addRule">
							<div class="row">
								<div class="form-group">
									<label>Category</label>
									<select class="form-control" v-model="form.categoryid" @change="getDivisions('form')">
										<option v-for="i in categories" :value="i.id">{{i.name}}</option>
									</select>
									<span class="badge badge-danger" v-if="errors.category">Please enter a valid category</span>
								</div>
								<div class="form-group">
									<label>Product</label>
									<select class="form-control" v-model="form.product">
										<option v-for="i in products" :value="i.product_name">{{i.product_name}}</option>
									</select>
									<span class="badge badge-danger" v-if="errors.product">Please enter a valid product</span>
								</div>
								<div class="form-group">
									<label>Division</label>
									<select class="form-control" v-model="form.division">
										<option v-for="i in divisions" :value="i.name">{{i.name}}</option>
									</select>
									<span class="badge badge-danger" v-if="errors.division">Please enter a valid division</span>
								</div>
								<div class="form-group" v-if="campaign.criteria == 'ITEM'">
									<label>Item Code</label>
									<input type="text" class="form-control" placeholder="Enter the item code" v-model="form.item_code">
									<span class="badge badge-danger" v-if="errors.item_code">Please enter a valid item code</span>
								</div>
								<div class="form-group" v-if="campaign.criteria == 'PRICE'">
									<label>Lower Limit</label>
									<input type="number" class="form-control" placeholder="Enter the lower limit" v-model="form.lower_limit" min="0">
									<span class="badge badge-danger" v-if="errors.lower_limit">Please enter a valid lower limit</span>
								</div>
								<div class="form-group" v-if="campaign.criteria == 'PRICE'">
									<label>Upper Limit</label>
									<input type="number" class="form-control" placeholder="Enter the upper limit" v-model="form.upper_limit" min="0">
									<span class="badge badge-danger" v-if="errors.upper_limit">Please enter a valid upper limit</span>
								</div>
								<div class="form-group">
									<label>Assigned Gift</label>
									<input type="text" class="form-control" placeholder="Enter the assigned gift" v-model="form.assigned_gift">
									<span class="badge badge-danger" v-if="errors.assigned_gift">Please enter a valid gift</span>
								</div>
								<div class="form-group">
									<label>Alloted Quantity</label>
									<input type="number" class="form-control" placeholder="Enter the alloted quantity" v-model="form.alloted_quantity" min="0">
									<span class="badge badge-danger" v-if="errors.alloted_quantity">Please enter a valid quantity</span>
								</div>
								<div class="form-group">
									<button class="btn btn-primary" type="submit">Add</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->

<div class="modal" tabindex="-1" role="dialog" id="changedialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Change Quantity</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
        	<label>Available Quantity</label>
        	<input type="number" class="form-control" placeholder="Enter the new available quantity" min="1" v-model="quantity">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="changeQnty">Save changes</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {pagination:Pagination},

        created(){
        	this.getCampaign();
        	this.getRules();
        	this.getCategories();
        	this.getProducts();
        	//this.getDivisions();
        },

        data(){
        	return {
        		campaign: {},
        		rules: [],
        		categories: [],
        		products: [],
        		divisions: [],
        		errors: [],
        		form: new Form({
        			category: '',
        			product: '',
        			division: '',
        			item_code: '',
        			lower_limit: '',
        			upper_limit: '',
        			assigned_gift: '',
        			alloted_quantity: '',
        			campaign: '',
        			criteria: '',
        			categoryid: ''
        		}),
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		product: null,
         		category: null,
         		division: null,
         		lower: null,
         		upper: null,
         		categoryid: null,
         		ruleid: '',
         		quantity: ''
        	}
        },

        methods: {
        	getCampaign(){
        		axios.post("/api/getGiftCampaign", {id: this.$route.params.id})
        		.then(response => {
        			this.campaign = response.data;
        		});
        	},

        	getRules(url = "/api/getGiftCampaignRules"){
        		axios.post(url, {campaign: this.$route.params.id, product: this.product, category: this.category, division: this.division, lower: this.lower, upper: this.upper})
        		.then(response => {
        			this.rules = response.data.data.data;
        			this.configPagination(response.data.data);
        		});
        	},

        	configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},

        	addRule(){
        		this.form.campaign = this.$route.params.id;
        		this.form.criteria = this.campaign.criteria;
        		this.form.post("/api/addGiftCampaignRule")
        		.then(response => {
        			toast.fire({
        				icon: 'success',
        				title: 'Rule Added'
        			});
        			this.getRules();
        			this.errors = [];
        		})
        		.catch((errors) => {
        			toast.fire({
        				icon: 'error',
        				title: 'Failed!'
        			});
        			this.errors = errors.response.data.errors;
        		});
        	},

        	getCategories(){
        		axios.post("/api/getGiftCategories", {campaign: this.$route.params.id})
        		.then(response => {
        			//console.log(typeof(this.categories));
        			this.categories = response.data;
        		});
        	},

        	getProducts(){
        		axios.post("/api/getMasterProductList")
        		.then(response => {
        			this.products = response.data;
        		});
        	},

        	getDivisions(type){
        		if(type == 'filter'){
        			var category = this.categoryid;
        		}
        		else if(type == 'form'){
        			var category = this.form.categoryid;
        			this.form.category = this.categories.find((x) => x.id == category).name;

        		}
        		axios.post("/api/getGiftSubCategories", {campaign: this.$route.params.id, category: category})
        		.then(response => {
        			this.divisions = response.data;
        		});
        	},

        	changePrompt(id){
        		this.ruleid = id;
        		$("#changedialog").modal("show");
        	},

        	changeQnty(){
        		axios.post("/api/changeGiftCampaignRule", {id: this.ruleid, quantity: this.quantity})
        		.then(response => {
        			if(response.data == 1){
        				toast.fire({
        					title: 'Changed',
        					icon: 'success'
        				});
		      			$("#changedialog").modal("hide");
		      			this.getRules();
		      		}
		      		else
		      			toast.fire({
        					title: 'Failed. Available quantity should be greater than or equal to alloted quantity.',
        					icon: 'error'
        				});
        		});
        	},

        	reset(){
        		this.product = null;
         		this.category = null;
         		this.division = null;
         		this.lower = null;
         		this.upper = null;
         		this.getRules();
        	}
        }
    }
</script>
